import type { SVGAttributes } from 'react';

import { ICONS, type IconName } from './icons';

export interface IconProps extends Omit<SVGAttributes<SVGSVGElement>, 'name'> {
  name: IconName;
  /** Side of the square it is drawn in, in pixels or any CSS length. */
  size?: number | string;
  /** What the icon means, when it stands alone. Without it the icon is decoration. */
  label?: string;
}

/** One glyph of the kit, in the current text colour. */
export function Icon({ name, size = 16, label, ...rest }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      data-icon={name}
      {...rest}
    >
      {ICONS[name]}
    </svg>
  );
}
